<!--
  -    Copyright (c) 2018-2025, lengleng All rights reserved.
  -
  - Redistribution and use in source and binary forms, with or without
  - modification, are permitted provided that the following conditions are met:
  -
  - Redistributions of source code must retain the above copyright notice,
  - this list of conditions and the following disclaimer.
  - Redistributions in binary form must reproduce the above copyright
  - notice, this list of conditions and the following disclaimer in the
  - documentation and/or other materials provided with the distribution.
  - Neither the name of the pig4cloud.com developer nor the names of its
  - contributors may be used to endorse or promote products derived from
  - this software without specific prior written permission.
  - Author: lengleng (wangiegie@gmail.com)
  -->
<template>
  <div class="execution">
    <basic-container>
      <avue-crud
        ref="crud"
        v-model="form"
        :page.sync="page"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        :before-open="beforeOpen"
        @on-load="getList"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @size-change="sizeChange"
        @current-change="currentChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="rowDel">
        <template v-if="rolesCode === 'ROLE_ADMIN'" slot="menuLeft">
          <el-button
            v-if="permissionList.tenantmenu"
            class="filter-item"
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="tenantMenu"
          >套餐维护
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { addObj, delObj, fetchPage, putObj } from '@/api/admin/tenant'
import { tableOption } from '@/const/crud/admin/tenant'
import { mapGetters } from 'vuex'

export default {
  name: 'Tenant',
  data() {
    return {
      tableData: [],
      searchForm: {},
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },
      tableLoading: false,
      tableOption: tableOption,
      menuProps: {
        label: 'name',
        value: 'id'
      },
      menuOptions: [],
      form: {}
    }
  },
  computed: {
    ...mapGetters(['permissions', 'rolesCode']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permissions.admin_systenant_add, false),
        delBtn: this.vaildData(this.permissions.admin_systenant_del, false),
        editBtn: this.vaildData(this.permissions.admin_systenant_edit, false),
        tenantmenu: this.vaildData(this.permissions.admin_systenant_tenantmenu, false)
      }
    }
  },
  methods: {
    getList(page, params) {
      this.tableLoading = true
      fetchPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params, this.searchForm)).then(response => {
        this.tableData = response.data.data.records
        this.page.total = response.data.data.total
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    rowDel: function(row, index) {
      var _this = this
      this.$confirm('是否确认删除ID为' + row.id, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return delObj(row.id)
      }).then(data => {
        _this.$message.success('删除成功')
        this.getList(this.page)
      })
    },
    handleUpdate: function(row, index, done, loading) {
      putObj(this.form).then(data => {
        this.$message.success('修改成功')
        done()
        this.getList(this.page)
      }).catch(() => {
        loading()
      })
    },
    handleSave: function(row, done, loading) {
      addObj(this.form).then(data => {
        this.$message.success('添加成功')
        done()
        this.getList(this.page)
      }).catch(() => {
        loading()
      })
    },
    searchChange(form, done) {
      this.searchForm = form
      this.page.currentPage = 1
      this.getList(this.page, form)
      done()
    },
    beforeOpen(show, type) {
      window.boxType = type
      show()
    },
    refreshChange() {
      this.getList(this.page)
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    currentChange(current) {
      this.page.currentPage = current
    },
    tenantMenu() {
      this.$router.push({
        path: '/admin/tenantmenu/index'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__right {
  display: none;
}
</style>
